import { render, staticRenderFns } from "./SizeColorDialog.vue?vue&type=template&id=48778618&scoped=true"
import script from "./SizeColorDialog.vue?vue&type=script&lang=js"
export * from "./SizeColorDialog.vue?vue&type=script&lang=js"
import style0 from "./SizeColorDialog.vue?vue&type=style&index=0&id=48778618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48778618",
  null
  
)

export default component.exports